import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'app-teams-charts',
    templateUrl: './teams.charts.component.html',
    styleUrl: './teams.charts.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TeamsChartsComponent {

  @Input() public flowChartData$;
  @Input() public runChartData$;
  @Input() public labelContent;
}
